.ks{color:var(--gray-900);}